import Flex from '@deprecated-ui/common/Flex';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import Image from 'global/Image';
import useForm from 'hooks/useForm';
import DATA_CY from 'constants/data-cy';
import { ButtonSend, Textarea } from './styled';

interface ShareInputProps {
  onSubmit: (message: string) => void;
  defaultMessage: string;
  isDisabled: boolean;
}

function ShareInput({ onSubmit, defaultMessage, isDisabled }: ShareInputProps) {
  const [message, setMessage] = useForm({ initialState: defaultMessage });

  const handleSubmit = () => {
    onSubmit(message);
  };

  const buttonIcon = isDisabled
    ? '/icon/arrow-submit-gray.svg'
    : '/icon/arrow-submit-green.svg';

  return (
    // @ts-expect-error
    <Flex justify="space-between" align="center" pt="5px">
      <Textarea
        placeholder="Write a comment..."
        value={message}
        defaultValue={defaultMessage}
        // @ts-ignore
        onChange={setMessage}
      />
      <ButtonSend
        onClick={handleSubmit}
        disabled={isDisabled}
        data-cy={DATA_CY.SHARE_POST.SEND_BUTTON}
      >
        <IconWrapper>
          <Image
            alt="Send to chat"
            src={buttonIcon}
            style={{ width: '21px', height: '21px' }}
          />
        </IconWrapper>
      </ButtonSend>
    </Flex>
  );
}

export default ShareInput;
